import { supabase } from './supabase';
import type { BreathingStyleRecord } from './api';

const TABLE = 'breathing_styles';

export async function listBreathingStyles(): Promise<BreathingStyleRecord[]> {
  const { data, error } = await supabase
    .from(TABLE)
    .select('*')
    .eq('active', true)
    .order('name', { ascending: true });

  if (error) throw error;

  return (data as BreathingStyleRecord[]) || [];
}
